export default __webpack_public_path__ + "static/media/logo-no-background.aeeb6a46.svg";